import styled, { createGlobalStyle } from "styled-components/macro";
import { spacing, colorState, typography, device } from "../Foundation";

export const boxShadow = "0px 3px 8px black";

interface tabItemProps {
    selectedtab?: boolean;
    disabled?: boolean;
}

interface MultiLineEllipsisProps {
    numberOfLine?: number;
}

const GlobalStyle = createGlobalStyle`
    div {
        color: '#f00';
    }
`;

interface DetailsPopupStylesProps {
    hoverbgColor?: string;
    Color?: boolean | string;
}

export const CenterContent = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const TabItem = styled.div<tabItemProps>`
    display: flex;
    padding: 6px 12px;
    justify-content: center;
    align-items: center;
    gap: ${spacing.spacing_6};
    border-radius: 100px;
    font-size: ${typography.size.ts};
    font-weight: ${typography.weight.medium};
    background: ${(props) =>
        props.selectedtab ? colorState.surface.brand.primary : colorState.surface.default.primary};
    color: ${(props) =>
        props.selectedtab ? colorState.text["primary-inverse"] : colorState.text.tertiary};
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
    max-height: 32px;
    width: 110px;
    flex: 0 0 auto;

    & > span {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        text-align: center;
    }

    &:hover {
        background: ${(props) =>
            props.selectedtab
                ? colorState.surface.brand.primary
                : colorState.surface.default.tertiary};
    }
`;

export const DetailsPopupStyles = styled.div<DetailsPopupStylesProps>`
    display: flex;

    /* stylelint-disable unit-no-unknown */
    max-height: 60dvh;
    position: absolute;
    right: 0;
    z-index: 2;

    .details-wrapper {
        overflow: auto;
        max-width: 200px;
        min-width: 150px;
        margin-top: ${spacing.spacing_8};
        display: flex;
        flex-direction: column;
        background-color: ${colorState.background["secondary-bg"]};
        padding: ${spacing.spacing_4};
        border-radius: ${spacing.spacing_12};
        box-shadow: 0 10px 15px -3px rgba(23, 23, 28, 0.1), 0 4px 6px -2px rgba(23, 23, 28, 0.05);

        .header {
            display: flex;
            padding: ${spacing.spacing_16};
            justify-content: space-between;

            h1 {
                color: ${colorState.text.primary};
                font-size: ${typography.size.tl};
                font-weight: ${typography.weight.semibold};
                line-height: ${spacing.spacing_28};
                margin-bottom: 0;
            }
        }

        .menu-items {
            list-style: none;
            background-color: ${colorState.surface.default.primary};
            margin-bottom: 0;
            padding: ${spacing.spacing_8};
            border-radius: ${spacing.spacing_12};
            overflow: auto;
            display: flex;
            flex-direction: column;

            .item {
                color: ${(props) =>
                    props.Color ? colorState.text.danger.primary : colorState.text.primary};
                font-weight: ${typography.weight.medium};
                font-size: ${typography.size.ts};
                line-height: ${spacing.spacing_20};
                padding: ${spacing.spacing_8};
                cursor: pointer;

                &:hover {
                    border-radius: ${spacing.spacing_8};
                    background-color: ${(props) => (props.hoverbgColor ? props.hoverbgColor : "")};
                    cursor: pointer;
                }
            }
        }
    }

    .options-wrapper {
        max-width: 340px;
        min-width: 250px;

        .options {
            padding: 0 !important;

            h2 {
                color: ${colorState.text.primary};
                font-size: ${typography.size.tm};
                font-weight: ${typography.weight.medium};
                line-height: ${spacing.spacing_24};
                margin-bottom: 0;
                white-space: nowrap;
            }

            .option-item {
                display: flex;
                flex-direction: column;
                gap: ${spacing.spacing_8};
                padding: ${spacing.spacing_12} ${spacing.spacing_20};
                border-bottom: 1px solid ${colorState.border.default.tertiary};

                &:hover {
                    border-radius: ${spacing.spacing_8};
                    background-color: ${(props) => (props.hoverbgColor ? props.hoverbgColor : "")};
                    cursor: pointer;
                }
            }
        }
    }

    .filter-wrapper {
        display: flex;
        flex-direction: column;
        padding: ${spacing.spacing_12};
        border-radius: ${spacing.spacing_12};
        background-color: ${colorState.surface.default.primary};
        min-width: 300px;
        max-width: 350px;
    }

    .footer-wrapper {
        display: flex;
        gap: ${spacing.spacing_16};
        justify-content: center;
        align-items: center;
        padding: ${spacing.spacing_20};
    }
    @media screen and (${device.md}) {
        max-height: 40dvh;
    }
`;

export const MultiLineEllipsis = styled.p<MultiLineEllipsisProps>`
    overflow: hidden;
    text-overflow: ellipsis;
    /* stylelint-disable */
    display: -webkit-box;
    -webkit-line-clamp: ${(props) => (props.numberOfLine ? props.numberOfLine : 2)};
    -webkit-box-orient: vertical;
    /* stylelint-enable */
    margin: 0;
    word-break: break-all;
`;

export default GlobalStyle;
